import React from 'react';

export const NavigationContext = React.createContext();

export default NavigationContext;
